import React from 'react';
import styles from './styles';

const TsDsDisplay = props => {

  const isTsDs = props.type !== undefined;
  const state = !isTsDs ? props.state : props.type === 'inc' ? props.incState.value : props.excState.value;
  const setState = !isTsDs ? props.setState : props.type === 'inc' ? props.incState.setter : props.excState.setter;
  const stateKeys = Object.keys(state);

  const handleChildDisplay = topLevelText => {
    let children = [];
    // closure to handle child construction from objects/arrays
    const parseItem = (item, lastKey) => {
      if (Array.isArray(item)) {
        // if array has values join with comma
        if (item.length) children.push(<React.Fragment key={item[0]}>
          <span style={styles.childValue}>{item.filter(arrItem => arrItem !== 'std_ignore').join(', ')}</span><br/>
        </React.Fragment>)
        // if array is empty add a break point
        else children.push(<br key={lastKey + '_br'}/>);
      } else if (typeof item === 'object') {
        Object.keys(item).forEach(itemKey => {
          if ((Array.isArray(item[itemKey]) && item[itemKey].length)
            || (!Array.isArray(item[itemKey]) && typeof item[itemKey] === 'object')
            // bold property with colon if has children
          ) children.push(<b style={styles.childProperty} key={itemKey}>{itemKey}: </b>)
          // span if no children
          else children.push(<span key={itemKey} style={styles.childProperty}>{itemKey}</span>);
          // parse next item
          parseItem(item[itemKey], itemKey)
        });
      } else {
        return children;
      }
    }
    parseItem(state[topLevelText], topLevelText)
    return children;
  }

  // return 'n/a' if null data and no selection set
  if ((props.data === null || props.data === undefined) && stateKeys.length === 0) return <span>N/A</span>;

  // data available return
  return(
    <div style={styles.container}>
      {stateKeys.map((topLevelText, i) => {
        return(
          <div key={topLevelText} style={styles.displayBox}>
            <h4 style={styles.topLevelText}>{topLevelText}</h4>
            {handleChildDisplay(topLevelText)}
          </div>
        )
      })}
    </div>
  )
}


  export default TsDsDisplay;
